import { SummaryCardItem } from './types';

const toneClasses: Record<NonNullable<SummaryCardItem['tone']>, string> = {
  default: 'text-gray-900',
  success: 'text-emerald-600',
  warning: 'text-amber-600',
  danger: 'text-red-600',
};

interface Props {
  items: SummaryCardItem[];
  columns?: 2 | 3 | 4 | 5;
}

export default function ReportSummaryCards({ items, columns = 4 }: Props) {
  const gridClass =
    columns === 2
      ? 'grid-cols-1 sm:grid-cols-2'
      : columns === 3
        ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3'
        : columns === 5
          ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-5'
          : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4';

  return (
    <div className={`grid gap-3 ${gridClass}`}>
      {items.map((item) => (
        <div key={item.label} className="rounded-lg border border-gray-100 bg-gray-50/80 p-4">
          <p className="text-xs font-medium uppercase tracking-wide text-gray-500">{item.label}</p>
          <p className={`mt-1 text-xl font-semibold ${toneClasses[item.tone || 'default']}`}>
            {item.value}
          </p>
        </div>
      ))}
    </div>
  );
}
